import useAxios from '../utils/useAxios'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const fetchAllUsers = createAsyncThunk('user/getAllUsers', (_, { rejectWithValue }) => {
    const api = useAxios();
    return api
      .get('/api/admin/account/users')
      .then(response => response.data)
      .catch(error => rejectWithValue(error))
})

export const createUser = createAsyncThunk('user/createUser', (value, { rejectWithValue }) => {
    const api = useAxios();
    return api
      .post('/api/admin/account/users/create', value)
      .then(response => response.data)
      .catch(error => rejectWithValue(error))
})

export const setUserPassword = createAsyncThunk('user/setPassword', (data, { rejectWithValue }) => {
    const { userId, password } = data;
    const api = useAxios();
    return api
      .post(`/api/admin/account/users/${userId}/set_password`, { password })
      .then(response => response.data)
      .catch(error => rejectWithValue(error))
})
